import React from 'react';
import ClassAssembly  from 'views/ClassAssembly2B2023';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;